








import { Component, Vue } from 'vue-property-decorator';
//@ts-ignore
import EasyCamera from 'easy-vue-camera';

@Component({
  components: {
    'v-easy-camera': EasyCamera
  }
})
export default class TireCamera extends Vue {
  public picture: any = "";

  mounted() {
    (this.$refs.camera as any).refCameraComponent.start().then((camera: any) => {
      if (camera) {
        camera.start()
          .finally(() => {
            if (camera.devices && camera.devices.length > 1) {
              (this.$refs.camera as any).refCameraComponent.switchCamera(true);
            }
          });
      }
    });
  }
  
  public onClose() {
    this.$emit("close");
  }

  public onSnap(data: any) {
    (this.$refs["camera"] as any).stop();
    this.$emit("snap", data);
  }

}
